import React from "react";
import PropTypes from 'prop-types'
import { Box, Text} from 'tailwind-react-ui';

function TermsAndConditionsModalComponent({showModal, setShowModal}){

    return (
    <>
        { showModal ? (
        <>
            <Box    
            className="justify-center fixed px-8 items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <Box onClick={() => setShowModal(!showModal)} className="absolute w-full h-full" style={{ backgroundColor: 'rgba(27, 27, 27, 0.75)' }}/>
                <Box className="relative w-auto my-6 mx-auto max-w-xl ">
                    {/*content*/}
                    <Box className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        {/*header*/}
                        <Box className="flex items-start justify-between rounded-t">
                            <Text is="p" text={'dark-light-gray'} className="quicksand-bold text-2xl mx-5 mt-5 ">
                                Términos y Condiciones
                            </Text>
                            <button
                                className="ml-auto bg-transparent border-0 text-black opacity-5 float-right text-5xl leading-none font-semibold outline-none focus:outline-none"
                                onClick={() => setShowModal(!showModal)}>
                                <Text is="span" text={'dark-light-gray'} className="quicksand-bold bg-transparent h-10 w-10 text-4xl block outline-none focus:outline-none">
                                ×
                                </Text>
                            </button>
                        </Box>
                        <Box inlineBlock className="relative text-dark-gray quicksand-regular w-full p-6 pl-12 flex-auto">
                            <ul className="list-disc">
                                <li className="mb-2">Válido a partir del 15 de julio al 15 de septiembre del 2020.</li>
                                <li className="mb-2">Válido en hoteles participantes.</li>
                                <li className="mb-2">Usuarios mayores de edad.</li>
                                <li className="mb-2">Las cervezas de regalo serán las clásicas que maneje cada motel.</li>
                            </ul>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
        ) : null}
    </>
    );
}

TermsAndConditionsModalComponent.propTypes = {
    showModal: PropTypes.bool,
    setShowModal: PropTypes.func
}

export default TermsAndConditionsModalComponent;
